<template>
	<div class="item-wrapper">
		<div class="preview">
			<transition name="fade">
				<span class="title" v-if="addToCartChosenItem == item.id">{{
					$t('Добавлено')
				}}</span>
			</transition>
			<div class="image-preview-wrapper">
				<div class="image-preview _ibg-contain">
					<img :src="imgDomain + item.image_url" />
				</div>
			</div>
		</div>
		<div class="preview-content">
			<div class="desc small name">
				<b>{{ item.title }}</b>
			</div>
			<div class="left">
				<div class="price desc small">
					<b>
						<span>
							{{ item.price }}
							<span class="currency">{{ currency }}</span>
						</span>
					</b>
				</div>
			</div>
			<button
				class="button shadowed"
				@click="$emit('addToCart', item, item.id)"
			>
				{{ $t('КУПИТЬ') }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductCard',
	props: ['item', 'currency', 'addToCartChosenItem'],
	data: function () {
		return {
			imgDomain: '',
		};
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	methods: {},
};
</script>
